import { $api } from "../generated/client";

/** `staleTime` overrides the client default for this observer only. */
export function useCurrentUser(options?: { staleTime?: number }) {
  return $api.useQuery("get", "/users/me", undefined, options);
}
